import {createStore} from 'vuex'

const store = createStore({
    state: {
        user: null,
        authUser: null,
        signedIn: false
    },
    mutations: {
        clearUser(state) {
            state.user = null;
            state.authUser = null;
            state.signedIn = false;
        },
        setUser(state, user) {
            state.user = user;
            state.signedIn = user != null;
        },
        setAuthUser(state, authUser) {
            state.authUser = authUser;
        },
        setSignedIn(state, signedIn) {
            state.signedIn = signedIn;
        }

    },
    getters: {
        user: state => {
            return state.user;
        },
        authUser: state => {
            return state.authUser;
        }
    }
})

export default store;
